/**
 * Permet de remplir la valeur d'un champ de formulaire
 *
 * @param   HTMLFieldElement   champ pour lequel remplir la valeur
 * @param   value               valeur à injecter dans le champ
 * @param   key                 Clé avec laquelle on à récupéré la valeur dans l'url ou les cookies
 */
export function setValue (HTMLFieldElement, value, key = null)
{
    //console.log(HTMLFieldElement);
    switch (HTMLFieldElement.nodeName.toLowerCase())
    {
        // Cas des champ de formulaire de type TEXTAREA
        case 'textarea':
            HTMLFieldElement.textContent = value
        break;

        // Cas des champs de formulaire de type SELECT
        case 'select':

            // Cas de la selection d'un pays dans les formulaires
            if(key.toString().toLowerCase() === 'pays')
            {
                return selectPaysOption(HTMLFieldElement, value, key);
            }

            // Cas normal, comparaison de valeur === valeur pour l'option du select
            const option = HTMLFieldElement.querySelector('option[value="'+value+'"]');
            if(option)
            {
                option.setAttribute('selected', 'selected')
                return true;
            }
        break;

        // Autres cas (input classique)
        default:
            HTMLFieldElement.setAttribute('value', value)
        break;
    }
}

/**
 * Permet de sélectionner l'option correspondant à un pays dans les formulaire (cas spécial)
 *
 * @param   HTMLFieldElement   champ pour lequel remplir la valeur
 * @param   value               valeur à injecter dans le champ
 * @param   key                 Clé avec laquelle on à récupéré la valeur dans l'url ou les cookies
 */
function selectPaysOption(HTMLFieldElement, value, key)
{
    // Cas classique ou on fait une comparaison valeur === valeur
    const option = HTMLFieldElement.querySelector('option[value="'+value+'"]');
    if(option !== undefined && option !== null)
    {
        option.setAttribute('selected', 'selected')
        return true;
    }

    // Parcourt les option et vérifie les 2 premiers caracètres
    const options = HTMLFieldElement.querySelectorAll('option');
    options.forEach(option => {

        const optionValue = option.getAttribute('value');

        // Si l'option n'a pas d'attribut value, retourne faux
        if(optionValue === undefined || optionValue === null)
        {
            return false;
        }

        // Si la valeur correspond à une longueur de 2, on compare le code du pays
        if(value.length === 2)
        {
            // Si les deux premiers caractère de l'attribut value, correspondent à la valeur du paramètre
            // On sélectionne le pays
            if(optionValue.substr(0, 2).toLowerCase() === value.toString().toLowerCase())
            {
                option.setAttribute('selected', 'selected')
                return true;
            }
        }
        else
        {
            //Sinon on essaye de vérifier le nom du pays
            if(optionValue.substr(3, optionValue.length).toLowerCase() === value.toString().toLowerCase())
            {
                option.setAttribute('selected', 'selected')
                return true;
            }
        }
    })

    return false;
}
